import { ref, onMounted, onUnmounted } from 'vue';

const TICK_INTERVAL_MS = 30000;

// Formats an epoch-ms timestamp as "5 minutes ago", "2 hours ago", etc.
// Returns '' for null/undefined so callers can just v-if on the input
// timestamp rather than on this return value.
export function formatTimeAgo(updatedAt) {
  if (!updatedAt) return '';

  const seconds = Math.floor((Date.now() - updatedAt) / 1000);
  if (seconds < 60) return 'just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} day${days === 1 ? '' : 's'} ago`;

  const weeks = Math.floor(days / 7);
  return `${weeks} week${weeks === 1 ? '' : 's'} ago`;
}

// A ref that ticks every 30s, purely so a "X ago" label kept on screen
// updates on its own — read (but ignore the value of) this inside a
// computed alongside formatTimeAgo() to make that computed re-evaluate as
// time passes, not just when the underlying timestamp itself changes.
export function useNowTicker() {
  const now = ref(Date.now());
  let timer = null;

  onMounted(() => {
    timer = setInterval(() => { now.value = Date.now(); }, TICK_INTERVAL_MS);
  });
  onUnmounted(() => clearInterval(timer));

  return now;
}
